import { Column, CreateDateColumn, Entity, VersionColumn, PrimaryGeneratedColumn, UpdateDateColumn } from "typeorm";



@Entity("employee_freebies")
export class EmployeeFreebiesEntity {
    @PrimaryGeneratedColumn('increment',{
        name:"employee_freebies_id"
    }) 
    employeeFreebiesId: number;

    @Column("int",{
        nullable:false,
        name:"employee_id"
    })
    employeeId: number;

    @Column("varchar",{
        nullable:false,
        name:"employee_code"
    })
    employeeCode: string;

    @Column("int",{
        nullable:false,
        name:"freebie_id"
    })
    freebieId: number;

    @Column("varchar",{
        nullable:false,
        name:"freebie_code"
    })
    freebieCode: string;

    @Column("int",{
        nullable:false,
        name:"original_count"
    })
    originalCount: number;

    @Column("int",{
        nullable:false,
        name:"available_count"
    })
    availableCount: number;

    @CreateDateColumn({
        name:"start_date",
        nullable: true,
    })
    startDate: Date;

    @CreateDateColumn({
        name:"end_date",
        nullable: true,
    })
    endDate: Date;

    @Column("int",{
        nullable:false,
        name:"year"
    })
    year: number;

    @Column("int", {
        nullable: false,
        name:"month"
    })
    month: number;

    @Column("int", {
        nullable: false,
        name:"max_consumption_per_day"
    })
    maxConsumptionPerDay: number;

    @Column("boolean",{
        nullable:false,
        default:true,
        name: 'is_active'
    })
    isActive: boolean | null;
    
    @Column("varchar", {
        nullable: false,
        length: 40,
        name:'created_user' 
    })
    createdUser : string | null;

    @CreateDateColumn({
        name:"created_at"
    })
    createdAt: Date;

    @Column("varchar",{
        nullable: true,
        length: 40,
        name:"updated_user"
    })
    updatedUser: string | null;

    @UpdateDateColumn({
        name:"updated_at"
    })
    updatedAt: Date;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;

}